import { jsx as u } from "react/jsx-runtime";
import { c } from "./index-65016bfa.mjs";
import p, { css as C } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as f } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { IconButton as B } from "./iconButton.js";
import { u as b } from "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./button.js";
import "react-dom";
import "./icon.js";
import "@fcamna/shared-icons";
const d = p(B)`
  &.CloseButton {
    ${({
  theme: {
    components: { closeButton: o }
  }
}) => C(o.CloseButton)}
  }
`, g = {
  default: "black",
  info: "default",
  success: "success",
  caution: "caution",
  danger: "danger"
}, D = ({
  surface: o = "light",
  color: t = "default",
  size: r = "xxsmall",
  onClick: e,
  ariaLabel: a = "Close",
  className: i,
  accessibilityOptions: s = { ariaLabel: a || "close button" },
  ...m
}) => {
  const l = f({ label: "Close Button" }), n = b("button", {
    ...s,
    ariaLabel: s.ariaLabel
  });
  return /* @__PURE__ */ u(
    d,
    {
      variant: "tertiary",
      color: g[t],
      className: c(["CloseButton", `CloseButton--${o}`, `CloseButton--${r}`, `CloseButton--${t}`, i]),
      onClick: e,
      iconName: "cancelClose",
      ...n,
      ...m,
      ...l
    }
  );
};
export {
  D as CloseButton
};
